import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FoodsService } from '../foods.service';
import { FoodsModel } from './FoodsModel';
import { CountriesService } from '../../MasterData/countries.service';
import { CountriesModel } from '../../MasterData/CountriesModel';
@Component({
    // moduleId: module.id,
    selector: 'all-foods',
    templateUrl: 'all-foods.component.html',
    styleUrls: ['all-foods.component.scss']
})
export class AllFoodsComponent implements OnInit {
    Menuoption = 'center';
    Settingicon = true
      projectDetails : any;
      projectGallaryConfig  = {"slidesToShow": 1,"fade": true, "slidesToScroll": 1,"arrows": false,"dots": false,"autoplay": true, "autoplaySpeed": 2000};
    declare lang: any;
  
      constructor( 
          public router: Router,
          private formBuilder : FormBuilder,
          private modelService :FoodsService,
          private CountriesService:CountriesService,
          private route: ActivatedRoute,
          ) {      this.id = +route.snapshot.paramMap.get("id");
         }
         id=0;
         
         ngOnInit() {
          this.lang = localStorage.getItem('theme_lang');
          debugger;
          this.modelService.getAll().subscribe(data=>{
              this.rows=data;
              console.log("modelObject",this.rows)
          })
          this.CountriesService.getAll().subscribe(data=>{
            this.CountriesList=data;
          })
          if(this.id > 0)
          {
            debugger;
            this.modelService.getById(this.id).subscribe(data=>{
              this.modelObject=data;
              this.files=this.modelObject.foodsImagesList;
              console.log("modelObject",this.rows)
  
            })
  
          }
          else{
          //   this.mainForm = this.createForm(this.modelObject);                              
          }
  
          // this.GetAllCountries();
          // this.mainForm = this.createForm(this.modelObject); 
      }
      selectedIndex: number = 0;
      @Input()
      data:any;
      modelObject: FoodsModel = new FoodsModel();
      mainForm: FormGroup = new FormGroup({
        id: new FormControl(),
        images: new FormControl(),
        nameAr: new FormControl(),
        nameEn: new FormControl(),
        nameFr: new FormControl(),
        descriptionAr: new FormControl(),
        descriptionEn: new FormControl(),
        descriptionFr: new FormControl(),
        countryId: new FormControl(),
        averageStar: new FormControl(),
    });
  createForm(modelObject): FormGroup {
      debugger;
      return this.formBuilder.group({
        Id: [modelObject.Id >= 0 ? modelObject.Id : 0],
        comimagesment: [modelObject.images >= 0 ? modelObject.images : 0],
        countryId: [modelObject.countryId >= 0 ? modelObject.countryId : 0],
      });
    }
      rows :FoodsModel[]= [];
      foodsListByCountry :FoodsModel[]= [];
      CountriesList :CountriesModel[]= [];
      
      getByCountry(){
        debugger;
             this.modelService.GetAllByCountryId(this.modelObject.countryId).subscribe(data=>{
               this.rows=data;
             })
              }

              getAllFoods(){
        debugger;
                this.modelService.getAll().subscribe(data=>{
                  this.rows=data;
                })
              }
   
        files:FoodsModel[]=[];
       public picurl: string ='';
       editEnabled = true;
       
     
       foodDetails(id){
          this.router.navigate(['/food-details/',id]);
          
        }
  }